@let branchData = branch();

<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="branchData.name">
  <div rightActions class="flex gap-2">
    <button
      panButton
      [disabled]="isUpdating() || selectedLocationIds().length === 0"
      color="info"
      (click)="setReviewCount.fire()"
      matTooltip="Set # reviews for selected locations"
    >
      Set # Reviews
    </button>

    <button
      panButton
      [disabled]="isUpdating() || selectedLocationIds().length === 0"
      color="info"
      (click)="matchSelectedReviewCounts()"
      matTooltip="Match assigned review counts for selected locations"
    >
      Match Assigned Counts
    </button>

    <swal
      #setReviewCount
      title="Set # Reviews"
      text="How many reviews would you like for the selected locations in {{ branchData.name }}?"
      input="number"
      [inputAttributes]="{ min: '0' }"
      [showCancelButton]="true"
      [focusCancel]="true"
      (confirm)="updateAllSelectedLocationCounts($event)"
      [confirmButtonText]="'Set Review Count'"
    >
    </swal>
  </div>

  @if (isLoading()) {
    <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading... </app-pan-blank-slate>
  } @else {
    <ag-grid-angular #usageGrid [rowData]="tableData()" [columnDefs]="usageColumns" [gridOptions]="usageTable"></ag-grid-angular>
  }
</app-pan-card>
